module.exports = __webpack_public_path__ + "img/edit2_pl.b422ea97.svg";